// ---------------------------------------------------------------
// announcementService.js — Tablón de anuncios de la farmacia.
// Colección `announcements`: { title, body, authorName, pinned,
// createdAt }. Los publica el ADMIN y los ve todo el equipo; a
// diferencia de las notificaciones, se quedan fijos en el tablón.
// Se leen sólo los últimos 5 (consulta ligera, sin índices).
// ---------------------------------------------------------------
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  writeBatch,
} from "firebase/firestore";
import { db } from "../firebase";

/** Últimos anuncios en tiempo real (por defecto 5) */
export function subscribeAnnouncements(onData, onError, max = 5) {
  const q = query(
    collection(db, "announcements"),
    orderBy("createdAt", "desc"),
    limit(max)
  );
  return onSnapshot(
    q,
    (snap) => {
      const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      // Orden manual si el admin lo ha colocado; si no, los más
      // recientes arriba (los nuevos siempre aparecen los primeros).
      docs.sort((a, b) => orderOf(a) - orderOf(b));
      onData(docs);
    },
    onError
  );
}

/** Posición efectiva: la manual, o "recién publicado" si no tiene */
const orderOf = (a) =>
  typeof a.order === "number" ? a.order : -(a.createdAt?.seconds || 0);

export function createAnnouncement({ title, body, authorName, pinned }) {
  return addDoc(collection(db, "announcements"), {
    title: title.trim(),
    body: (body || "").trim(),
    authorName: authorName || "Administración",
    pinned: !!pinned,
    readBy: {},
    createdAt: serverTimestamp(),
  });
}

/** El admin edita un anuncio ya publicado */
export function updateAnnouncement(id, { title, body, pinned }) {
  return updateDoc(doc(db, "announcements", id), {
    title: title.trim(),
    body: (body || "").trim(),
    pinned: !!pinned,
    editedAt: serverTimestamp(),
  });
}

/** Guarda el orden manual del tablón (ids en el orden deseado) */
export function reorderAnnouncements(ids) {
  const batch = writeBatch(db);
  ids.forEach((id, i) => batch.update(doc(db, "announcements", id), { order: i }));
  return batch.commit();
}

/** Cada usuario marca que HA LEÍDO un anuncio (sólo su propia marca) */
export function markAnnouncementRead(id, uid) {
  return updateDoc(doc(db, "announcements", id), { [`readBy.${uid}`]: true });
}

export function togglePinAnnouncement(id, pinned) {
  return updateDoc(doc(db, "announcements", id), { pinned: !!pinned });
}

export function deleteAnnouncement(id) {
  return deleteDoc(doc(db, "announcements", id));
}
